import { render, staticRenderFns } from "./map.vue?vue&type=template&id=5bf8ff3e&scoped=true&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8ff3e",
  null
  
)

export default component.exports